import { Box, Button, Flex, HStack, Image, Link, Spacer, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../../components/LoadingSpinner';
import { displayRow } from '../../../helpers/general';
import useWhiteLabelOrganizationQuery from '../../../hooks/useWhiteLabelOrganizationQuery';
import { ContentCard } from '../../../layout/ContentCard';

const WhiteLabelOrganizationSummaryCard = (props: { whiteLabelOrganizationId: number }) => {
  const { whiteLabelOrganizationId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const whiteLabelOrganizationQuery = useWhiteLabelOrganizationQuery(whiteLabelOrganizationId);

  if (whiteLabelOrganizationQuery.isLoading) {
    return <LoadingSpinner />;
  }

  // @ts-ignore
  return (
    <ContentCard
      isLoading={whiteLabelOrganizationQuery.isFetching}
      header={`${t('pages:whitelabel_organizations.organization.label')} ${whiteLabelOrganizationQuery.data?.name}`}
    >
      <Stack w={'100%'} data-test-id="whitelabel-organization-details-summary-card">
        <HStack>
          <Flex alignItems={'center'}>
            {whiteLabelOrganizationQuery.data?.logo_url && (
              <Image
                src={`${whiteLabelOrganizationQuery.data?.logo_url}`}
                w={'20%'}
                h={'auto'}
                mr={5}
                fallback={
                  <Flex justifyContent={'center'} alignItems={'center'}>
                    <Text fontSize={'sm'} color={'gray.400'}>
                      {t('pages:whitelabel_organizations.wrong_logo_url')}
                    </Text>
                  </Flex>
                }
              />
            )}
            <Box minWidth={'300'} ml={50}>
              {whiteLabelOrganizationQuery.data?.logo_url &&
                displayRow({
                  label: t('pages:whitelabel_organizations.organization.logo_url'),
                  content: `${whiteLabelOrganizationQuery.data?.logo_url}`,
                  isLoading: whiteLabelOrganizationQuery.isLoading,
                })}
              {displayRow({
                label: t('pages:whitelabel_organizations.organization.name'),
                content: `${whiteLabelOrganizationQuery.data?.name}`,
                isLoading: whiteLabelOrganizationQuery.isLoading,
              })}
              {displayRow({
                label: t('pages:whitelabel_organizations.organization.domain'),
                content: <Link>{whiteLabelOrganizationQuery.data?.domain}</Link>,
                isLoading: whiteLabelOrganizationQuery.isLoading,
              })}
            </Box>
          </Flex>
          <Spacer />
          <Flex>
            <Box mt={'90%'}>
              <Button
                variant="primary"
                onClick={() => {
                  navigate(`/app/op/whitelabel-organizations/update/${whiteLabelOrganizationId}`);
                }}
              >
                {t('common:update')}
              </Button>
            </Box>
          </Flex>
        </HStack>
      </Stack>
    </ContentCard>
  );
};

export default WhiteLabelOrganizationSummaryCard;
